import React, { useState, useEffect } from "react";
import ExporterLogin from "./ExporterLogin";
import ExporterContent from "./ExporterContent";
import { apiClientExporter } from "../../services/apiClient";

const AuthController = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [contentData, setContentData] = useState(null);
    const [quartersData, setQuartersData] = useState(null);
    const [profileData, setProfileData] = useState(null);

    const validateToken = async () => {
        const token = localStorage.getItem("exporterAuthToken");

        if (!token) {
            setIsAuthenticated(false);
            setIsLoading(false);
            return;
        }

        await getData(token);
        await getDataJefeJudicial(token);

    };

    const getData = async (token) => {
        try {
            const response = await apiClientExporter.get(`/exporter/claims`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            const data = response.data;
            setContentData(data);
            console.log("data", data);
            setIsAuthenticated(true);
            await getUserProfile();

        } catch (err) {
            console.error(err.message);
            localStorage.removeItem("exporterAuthToken");
            setIsAuthenticated(false);
        } finally {
            setIsLoading(false);
        }
    }
    const getDataJefeJudicial = async (token) => {
        try {
            const response = await apiClientExporter.get(`/exporter/claims_quarter`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            const data = response.data;
            setQuartersData(data);
            console.log("dataQuarters", data);

        } catch (err) {
            console.error(err.message);
        }
    }

    const getUserProfile = async () => {
        const token = localStorage.getItem("exporterAuthToken");

        if (!token) {
            setIsAuthenticated(false);
            return;
        }

        try {
            const response = await apiClientExporter.get(`/user/exporterprofile`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            console.log("responseProfile", response);

            const data = response.data;
            setProfileData(data);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        validateToken();
    }, []);

    const handleLoginSuccess = () => {
        setIsLoading(true);
        validateToken();
    };

    const handleLogout = () => {
        setIsLoading(true);
        validateToken(); // Re-validate token after logout
    };

    if (isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    backgroundColor: "#f5f5f5",
                }}
            >
                <p>Loading...</p>
            </div>
        );
    }

    return isAuthenticated ? (
        <ExporterContent data={contentData} quartersData={quartersData} profileData={profileData} onLogout={handleLogout} />
    ) : (
        <ExporterLogin onLoginSuccess={handleLoginSuccess} />
    );
};

export default AuthController;